export default __webpack_public_path__ + "static/media/frxETH.1e1c8dd2.png";